import React, { createContext, useState, useContext, useEffect } from 'react';

// Create the context
export const GuestContext = createContext();

export const GuestProvider = ({ children }) => {
  // State to hold the selected language
  const [language, setLanguage] = useState('English'); // Default language

  const [loading, setLoading] = useState(false);
  const [pageBanner, setPageBanner] = useState(1); // Default language
  const [viewingEvent, setViewingEvent] = useState(() => {
    // Uncomment the next line to always start with VegeFest (ignores sessionStorage)
    // sessionStorage.removeItem('viewingEvent');

    const savedEvent = sessionStorage.getItem('viewingEvent');
    const defaultEvent = 'budhabath';
    console.log('Initial viewingEvent - saved:', savedEvent, 'default:', defaultEvent);
    return savedEvent || defaultEvent;
  });

  // const [selectedSession, setSelectedSession] = useState(() => {
  //   return sessionStorage.getItem('selectedSession');
  // });

  const [selectedSession, setSelectedSession] = useState(null);

  // switchSession updates the selected session
  const switchSession = (newSession) => {
    setSelectedSession(newSession);
  };


  useEffect(() => {
    sessionStorage.setItem('viewingEvent', viewingEvent);
  }, [viewingEvent]);

  const switchEvent = (event) => {
    setViewingEvent(event)
  }
  // const switchSession = (event) => {
  //   setSelectedSession(event)
  // }

  // Function to toggle language
  const toggleLanguage = () => {
    setLanguage(prevLanguage => (prevLanguage === 'English' ? 'Chinese' : 'English'));
  };

  return (
    <GuestContext.Provider value={{ language, toggleLanguage, pageBanner, setPageBanner, loading, setLoading, viewingEvent, switchEvent, switchSession, selectedSession }}>
      {children}
    </GuestContext.Provider>
  );
};

// Custom hook to use the GuestContext
export const useGuestContext = () => useContext(GuestContext);
